import { useEffect, useState } from 'react';

import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
import { useModal } from 'react-modal-hook';

import { ReactComponent as EncaminharMensagensIcon } from 'assets/images/forward-icon.svg';
import ModalListaContatos from 'components/ModalListaContatos';
import { useAppDispatch, useAppSelector } from 'store';
import { ContatoInterface } from 'store/reducers/contatos';
import {
  mensagensSelector,
  resetMensagensParaEncaminhar,
} from 'store/reducers/mensagens';

import ModalEncaminharMensagens from './ModalEncaminharMensagens';

const useStyles = makeStyles(() => ({
  tooltip: {
    fontSize: 12,
  },
}));

export default function ButtonEncaminharMensagens() {
  const { totalMensagensParaEncaminhar } = useAppSelector(mensagensSelector);
  const dispatch = useAppDispatch();

  const classes = useStyles();

  const [contatoSelected, setContatoSelected] = useState<ContatoInterface>();

  const handleSelect = (contato: ContatoInterface) => {
    setContatoSelected(contato);

    hideModalListaContatos();
    showModalEncaminharMensagens();
  };

  const [showModalListaContatos, hideModalListaContatos] = useModal(
    ({ in: open }) => (
      <ModalListaContatos
        open={open}
        onClose={hideModalListaContatos}
        selected={contatoSelected}
        onSelect={handleSelect}
      />
    ),
    [contatoSelected],
  );

  const [showModalEncaminharMensagens, hideModalEncaminharMensagens] = useModal(
    ({ in: open }) => (
      <ModalEncaminharMensagens
        open={open}
        onClose={() => {
          hideModalEncaminharMensagens();
          setContatoSelected(undefined);
        }}
        contato={contatoSelected}
        onChangeContatoSelected={() => showModalListaContatos()}
        onSuccess={() => {
          setContatoSelected(undefined);
          dispatch(resetMensagensParaEncaminhar());
        }}
      />
    ),
    [contatoSelected],
  );

  useEffect(() => {
    return () => {
      setContatoSelected(undefined);
    };
  }, []);

  return (
    <Tooltip
      arrow
      title="Encaminhar mensagens"
      classes={{ tooltip: classes.tooltip }}
    >
      <IconButton
        onClick={showModalListaContatos}
        disabled={totalMensagensParaEncaminhar === 0}
        disableRipple
      >
        <EncaminharMensagensIcon color="action" />
      </IconButton>
    </Tooltip>
  );
}
